'use strict';

(function(window, document){
	// ----------------------------------- [START] Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws,
		html = document.documentElement,
		body = document.body;

	// // 取得Window設定值
	// var windowSetting = function () {
	// 	ww = win.innerWidth();
	// 	wh = win.innerHeight();
	// 	ws = win.scrollTop();
	// }
	// windowSetting();
	// registerListener('resize', throttle(windowSetting, 50, 100));

	// -----------------------------
	// 取得裝置判斷
	var isMobile = false,
		isTablet = false,
		isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true
		}
	}
	deviceDetect();
	registerListener('resize', throttle(deviceDetect, 50, 100));
	// ----------------------------------- [END] Setting


	// 新增Header特殊固定(黑色區塊PC版不Fixed)
	body.classList.add('hd-fixed--main-nav-only');


	/* ----------------------------------- [START] Swiper Tool */
	/*
	* Swiper Set Tab
	*/
	/** 增加Swiper因設定Loop產生的重複物件不能用Tab Focus
	 * @param {Object} target - 傳入 swiperTargetEl.parentElement，Build Swiper父層
	 */
	function swiperLoopTabRemove(target) {
		setTimeout(() => {
			var swiperLoopCopyItem = target.querySelectorAll('.swiper-slide-duplicate');
			[].forEach.call(swiperLoopCopyItem, function(item) {
				if (item.tagName === 'A') {
					item.setAttribute('tabindex', -1)
				} else {
					var insideLink = item.querySelectorAll('a, button')
					for (let i = 0; i < insideLink.length; i++) {
						insideLink[i].setAttribute('tabindex', -1)
					}
				}
			});
		}, 500);
	}

	/*
	* 外層增加 tabindex，可以focus，讓鍵盤可以操控
	*/
	function swiperLoopTabAdd(target, swiper) {
		if (!isMobile) {
			var swiperSlideItem = target.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
			[].forEach.call(swiperSlideItem, function(item) {
				// Add tabindex
				item.setAttribute('tabindex', 0);

				// Focus Change Slide (PC)
				item.addEventListener('focus', function() {
					if(!isMobile) {
						var elIndex = $(item).index();
						swiper.lazy.loadInSlide(elIndex + 1);
					}
				});
			});
		}
	}

	/* 無障礙(Accessibility)輔助文字總設定 */
	var a11y = {
		enabled: true,
		prevSlideMessage: '上一項',
		nextSlideMessage: '下一項',
		firstSlideMessage: '第一項',
		lastSlideMessage: '最後一項',
		paginationBulletMessage: '去第{{index}}項'
	};
	/* ----------------------------------- [END] Swiper Tool */

	/* --------------------------------------- */
	/*
	* 調整Grid位置
	*/
	var isIE = document.documentElement.browser === 'IE'
	var useCssGrid = !isIE;
	registerListener('load', function() {
		useCssGrid = Modernizr.cssgrid;
	})

	var album = $('#album-list');
	var albumList = album.children('li');

	var albumLayoutClassSp = 'layout-sp';
	var albumLayoutClassSpItem = 'column-auto';

	// Breakpoint
	// ------------------------------------------
	// Breakpoint	| 1 | 2 | Group
	// ------------------------------------------
	// 0 ~ 639		| F | F |   5
	// ------------------------------------------
	// 640 ~ 1023	| T | F |   6
	// ------------------------------------------
	// 1024+		| T | T |  10
	// ------------------------------------------
	var albumLayout__breakpoint1 = window.matchMedia('(min-width: 640px)');
	var albumLayout__breakpoint2 = window.matchMedia('(min-width: 1024px)');

	var albumGroupGet = function() {
		var group = 0;
		var col = 0;
		if(albumLayout__breakpoint1.matches && albumLayout__breakpoint2.matches) {
			// 1024+
			group = 10;
			col = 4;
		} else if (albumLayout__breakpoint1.matches && !albumLayout__breakpoint2.matches) {
			// 640 ~ 1023
			group = 6;
			col = 3;
		} else {
			// 0 ~ 639
			group = 5;
			col = 2;
		}
		var result = {
			group: group,
			col: col,
			sp: group / 2 + ((group / 2 - 1) / 2) // 修正的物件(Medium: 5 | Large: 8, 9)
		}
		return result
	}

	var albumArrayBuild = function() {
		albumList = album.children('li');

		if(useCssGrid) {
			// 支援 CSS Grid
			albumItemSet();
		} else {
			// 不支援 CSS Grid
			albumLayoutPolyfill();
		}
	}

	var albumItemSet = function () {
		var groupData = albumGroupGet();
		var group = groupData.group;
		var groupSpPoint = groupData.sp;
		var itemSpCache = {}; // 紀錄要增加修正的物件(Medium: 5 | Large: 8, 9)

		albumList.each( function (index, el) {
			var visualIndex = index + 1; // 從1開始

			// 移除特殊排版
			el.classList.remove(albumLayoutClassSpItem);

			// 設定排序(除以Group餘數)，目前不需要設定data-layout
			var layout = visualIndex % group;
			el.dataset.layout = layout !== 0 ? layout : group;

			// 紀錄可能需要特殊排版的物件
			if(layout !== 0 && layout % group > groupSpPoint ) {
				if(itemSpCache[layout] === undefined) {
					itemSpCache[layout] = [];
				}
				itemSpCache[layout] = el;
			}
			
			// Last
			if(index === albumList.length - 1) {
				album.removeClass(albumLayoutClassSp);
				// 總數
				if(albumLayout__breakpoint1.matches) {
					// 640+
					if(visualIndex % group !== 0 && visualIndex % group > groupSpPoint) {
						album.addClass(albumLayoutClassSp);
						// 增加SP排版
						Object.keys(itemSpCache).map(function(objectKey) {
							var el = itemSpCache[objectKey];
							el.classList.add(albumLayoutClassSpItem)
						});
					}
				}
			}
		});
	}

	// ----------------------------------------------------
	// 不支援 CSS Grid
	var albumLayoutPolyfillInit = false;
	var albumLayoutResizeTimer = null;
	var albumLayout = {}

	var albumLayoutPolyfill = function() {
		if(!albumLayoutPolyfillInit) {
			albumLayoutPolyfillInit = true;
			albumLayoutPolyfillOptGet();
			album.addClass('layout-load');
		}
		albumLayoutPolyfillSet();
	}

	var albumLayoutPolyfillResize = function() {
		if(albumLayoutResizeTimer !== null) clearTimeout(albumLayoutResizeTimer);
		albumLayoutResizeTimer = setTimeout(function(){
			albumLayoutResizeTimer = null;
			albumLayoutPolyfillOptGet();
			albumLayoutPolyfillSet();
		}, 100);
	}
	
	var albumLayoutPolyfillOptGet = function() {
		var groupData = albumGroupGet();

		albumLayout = {
			col: groupData.col,
			group: groupData.group,
			gap: albumLayout__breakpoint1.matches ? 20 : 10,
			isL: groupData.col === 4,
			isM: groupData.col === 3,
			sp: groupData.sp
		}
		albumLayout.size = (album.innerWidth() - (albumLayout.col - 1) * albumLayout.gap) / albumLayout.col;
		albumLayout.sizeL = albumLayout.size * 2 + albumLayout.gap;
		albumLayout.oneGroup = albumLayout.sizeL * 2 + albumLayout.gap;

		var oneGridGap = albumLayout.size + albumLayout.gap
		var pos = {
			1: 0,
			2: oneGridGap,
			3: oneGridGap * 2,
			4: oneGridGap * 3
		}

		albumLayout.pos = pos;
	}

	var albumLayoutPolyfillSet = function() {
		var group = albumLayout.group,

			albumLen = albumList.length,

			// 餘數的高
			remainder = albumLen % group,
			remainderHeight = remainder === 0 ? 0 : remainder <= albumLayout.group / 2 ? albumLayout.sizeL : albumLayout.sizeL + albumLayout.size + albumLayout.gap,

			// 完整的Group
			fillGroup = Math.floor(albumLen / group),
			fillGroupHeight = fillGroup > 0 ? fillGroup * albumLayout.oneGroup + (fillGroup - 1) * albumLayout.gap : 0,

			albumHeight = fillGroupHeight + remainderHeight;

		// 總高
		album.height(albumHeight);

		albumList.each( function (index, el) {
			var layout = (index + 1) % group;
			var groupIndex = Math.floor(index / group);

			var standardTop = groupIndex * (albumLayout.oneGroup + albumLayout.gap); // 基本高
			var left, top;
			var posX = 0, posY = 0;

			var isM = albumLayout.isM;

			if (layout === 1) {
				// Group的第一個
				posX = 1;
				posY = 1;
			} else if (layout === 0){
				// Group的最後一個
				posX = isM ? 2 : 3;
				posY = 3;
			} else {
				if(layout <= albumLayout.group / 2) {
					// 前半
					if(isM) {
						// Medium
						posX = 3;
						posY = layout === 2 ? 1 : 2;
					} else {
						// Large
						posX = layout === 2 || layout === 4 ? 3 : 4;
						posY = layout === 2 || layout === 3 ? 1 : 2;
					}
				} else {
					// 後半
					if(isM) {
						// Medium
						posX = 1;
						posY = layout === 4 ? 3 : 4;

						// 如果數量上未達到滿版
						if(remainder > albumLayout.sp && layout === 5) {
							posX = 2;
							posY = 3;
						}
					} else {
						// Large
						posX = layout === 6 || layout === 8 ? 1 : 2;
						posY = layout === 6 || layout === 7 ? 3 : 4;

						// 如果數量上未達到滿版
						if(remainder > albumLayout.sp && layout > albumLayout.sp) {
							posX = layout === 8 ? 3 : 4;
							posY = 3;
						}
					}
				}
			}

			left = albumLayout.pos[posX];
			top = standardTop + albumLayout.pos[posY];

			el.style.cssText = 'position: absolute; top:' + top + 'px; left:' + left + 'px;'
		});
	}

	// ----------------------------------------------------
	// Init
	var albumLayoutInit = function () {
		albumArrayBuild();
		if(useCssGrid) {
			// 支援 CSS Grid
			albumLayout__breakpoint1.addListener(albumArrayBuild);
			albumLayout__breakpoint2.addListener(albumArrayBuild);
		} else {
			// 不支援 CSS Grid
			registerListener('resize', albumLayoutPolyfillResize);
		}
	}
	registerListener('load', albumLayoutInit);

	/* --------------------------------------- */
	/*
	* 篩選商品項目
	*/
	var filterNav = $('.nav-filter-cat a');

	var filterResult = $('.filter-cat-results');

	var filterActive; // 紀錄目前Active的分類
	var filterActiveClass = 'active';

	var albumJson = null;
	var albumListCache = {};

	var openIndex = null; // 紀錄Modal開起來第幾個

	var png1x1 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

	// 取得相簿JSON資料
	var albumJsonGet = function(callback) {
		$.ajax({
			url: filterResult.data('json'),
			type: 'GET',
			dataType: 'json',
			success: function(res) {
				albumJson = res;
				// 建立第一分類Cache
				filterCategoryInit();
				if(typeof callback === 'function') callback();
			},
			error: function(request, msg, error) {
				console.error('無法讀取圖片資料', request, msg, error)
			}
		})
	}
	albumJsonGet();

	// 列表HTML
	var albumItemHTMLReturn = function(data) {
		var albumItemHtml = `<li class="album-list__item f-cat">
			<a class="album-list__img-box object-fit offset-outer" href="javascript:;" data-open="modal-slider" title="${data.text}">
				<img class="lazy" src="${png1x1}" data-src="${data.img}" alt="${data.alt}"/>
				<div class="album-list__text">${data.text}</div>
			</a>
		</li>`;
		var result = $(albumItemHtml);
		return result
	}

	var albumItemClick = function() {
		openIndex = $(this).parent().index();
	}

	// Slider HTML
	var albumSliderHTMLReturn = function(data, index) {
		var result;
		if(data.href !== undefined) {
			result = `<figure class="swiper-slide" tabindex="0" aria-labelledby="photo-desc-${index}">
				<a href="${data.href}" target="_blank" title="${data.title} [另開新視窗]">
					<div class="gallery-modal__photo__gallery-top__img-box">
						<div class="swiper-zoom-container"><img class="swiper-lazy" src="${png1x1}" data-src="${data.img}" alt="${data.alt}" /></div><noscript><img src="val.img" alt=""/></noscript></div>
					<div class="gallery-modal__photo__gallery-top__desc" id="photo-desc-${index}">${data.text}</div>
				</a>
			</figure>`;
		} else {
			result = `<figure class="swiper-slide" tabindex="0" aria-labelledby="photo-desc-${index}">
				<div class="gallery-modal__photo__gallery-top__img-box">
					<div class="swiper-zoom-container"><img class="swiper-lazy" src="${png1x1}" data-src="${data.img}" alt="${data.alt}" /></div><noscript><img src="val.img" alt=""/></noscript></div>
				<div class="gallery-modal__photo__gallery-top__desc" id="photo-desc-${index}">${data.text}</div>
			</figure>`;
		}
		return result
	}

	function filterCategoryInit() {
		if(galleryTopModal === undefined) return false;

		filterActive = filterNav.filter('.active').attr('data-cat');
		var currentCate = {};
		var filterResultItem = filterResult.children('li');
		var slides = galleryTopModal.slides;

		currentCate.list = [];
		currentCate.slides = [];

		for(var i = 0; i < filterResultItem.length; i++) {
			currentCate.list[i] = filterResultItem.eq(i);
			filterResultItem.eq(i).find('a').on('click', albumItemClick);
		}

		for(var i = 0; i < slides.length; i++) {
			currentCate.slides[i] = slides[i];
		}

		albumListCache[filterActive] = currentCate;
	}

	function filterCategory(category, callback) {
		if (filterActive != category) {
			if(albumListCache[category] === undefined) {
				if(albumJson === null) return false;

				var currentCate = {};

				for(var i = 0; i < albumJson.length; i++) {
					if(albumJson[i].cate === category) {
						currentCate.data = albumJson[i].list;
						break;
					}
				}

				currentCate.list = [];
				currentCate.slides = [];
				for(var i = 0; i < currentCate.data.length; i++) {
					if(i < 10) {
						currentCate.list.push(albumItemHTMLReturn(currentCate.data[i]));
					}
					currentCate.slides.push(albumSliderHTMLReturn(currentCate.data[i], i));
				}

				albumListCache[category] = currentCate;
			}

			// 紀錄原資料
			// if(albumListCache[filterActive] !== undefined) {
			// 	var currentCate = albumListCache[filterActive];
			// 	var filterResultItem = filterResult.children('li');
			// 	var slides = galleryTopModal.slides;
			// 	for(var i = 0; i < filterResultItem.length; i++) {
			// 		currentCate.list[i] = filterResultItem.eq(i);
			// 	}
			// 	for(var i = 0; i < slides.length; i++) {
			// 		currentCate.slides[i] = slides[i];
			// 	}
			// 	albumListCache[filterActive] = currentCate;
			// }

			// Append List
			filterResult.html('');
			for(var i = 0; i < albumListCache[category].list.length; i++) {
				var item  = albumListCache[category].list[i];

				// IE如果不Clone會有第二次以上無法出現之問題
				if(isIE) item = item.clone();

				// 設定Click事件
				item.children('a').on('click', albumItemClick);

				filterResult.append(item);
			}

			// Lazy Load
			body.setLazy();
			setTimeout(function() {
				imglazyload();
			}, 100);

			// Append Slider
			if(galleryTopModal !== undefined) {
				// 如果Modal還沒開起來會有無法刪除的Bug，原因不明
				galleryTopModal.modalInit = false;
				if(!galleryTopModal.modalInit) {
					galleryTopModal.removeAllSlides();
				}
				galleryTopModal.removeAllSlides();

				var loop = albumListCache[category].slides.length > 2;

				if(loop && !galleryTopModal.params.loop) {
					galleryTopModal.params.loop = true;
					galleryTopModal.navigation.nextEl.classList.remove('swiper-button-disabled');
					galleryTopModal.navigation.prevEl.classList.remove('swiper-button-disabled');
					galleryTopModal.navigation.nextEl.classList.remove('hide');
					galleryTopModal.navigation.prevEl.classList.remove('hide');
				} else if (!loop && galleryTopModal.params.loop) {
					galleryTopModal.params.loop = false;
					galleryTopModal.navigation.nextEl.classList.add('hide');
					galleryTopModal.navigation.prevEl.classList.add('hide');
				}
				
				for(var i = 0; i < albumListCache[category].slides.length; i++) {
					galleryTopModal.appendSlide(albumListCache[category].slides[i]);
				}
			}

			// reset active filter
			filterActive = category;
			filterNav.removeClass(filterActiveClass);

			// Callback
			if(typeof callback === 'function') callback();
		}
	}

	var activeIndex = 0; // Active Index (鍵盤操控需要)
	var tagA = filterNav; // Tag 數量 (鍵盤操控需要)
	var tagLen = tagA.length; // Tag 數量 (鍵盤操控需要)

	filterNav.click(function() {
		var $self = $(this);
		filterCategory($self.attr('data-cat'), function() {
			$self.addClass(filterActiveClass);
			albumArrayBuild();
		});
	});

	/* ------------------------------------ [START] 篩選鍵盤操控 */
	var $doc = $(document);
	var timer = null; // 紀錄 setTimeout
	var docListener = false; // 紀錄是否監聽鍵盤事件（避免重複監聽）

	/* KeyCode */
	var key = {
		left: 37,
		right: 39
	}

	/* 鍵盤事件 */
	function docKeyDown(e) {
		docListener = true
		if (e.keyCode === key.right) {
			activeIndex = (activeIndex + 1 + tagLen) % tagLen;
			docKeyDownAfter();
		} else if (e.keyCode === key.left) {
			activeIndex = (activeIndex - 1 + tagLen) % tagLen;
			docKeyDownAfter();
		}
	}

	/* 確認要更改產生的事件 */
	function docKeyDownAfter() {
		var currentTagA = tagA.eq(activeIndex);
		
		filterCategory(currentTagA.attr('data-cat'));

		currentTagA.addClass('active');
		currentTagA.focus();
	}

	/* Focus → 監聽鍵盤事件 */
	filterNav
		.on('focus', function() {
			timer && clearTimeout(timer);
			if (!docListener && !isMobile) {
				$doc.on('keydown', docKeyDown);
			}
		})
		.on('focusout', function() {
			timer && clearTimeout(timer);
			timer = setTimeout(function() {
				if (docListener && !isMobile) {
					$doc.off('keydown', docKeyDown);
					docListener = false;
				}
			}, 1000);
		});

	/* ------------------------------------ [END] 篩選鍵盤操控 */

	/* --------------------------------------- */
	/*
		* Lightbox
		*/
	var galleryTopModal;
	var buildSwiper__albumLightbox = function() {
		if (document.querySelector('.gallery-top-modal') === null) return false;

		/* Modal(Popup)*/
		var swiperTarget = '.gallery-top-modal',
			swiperTargetEl = document.querySelector(swiperTarget),
			swiperEl = swiperTargetEl.parentElement,
			swiperNextEl = swiperEl.querySelector('.swiper-button-next'),
			swiperPrevEl = swiperEl.querySelector('.swiper-button-prev'),
			swiperPageEl = swiperEl.querySelector('.swiper-pagination'),
			swiperSlide = swiperTargetEl.querySelectorAll('.swiper-slide'),
			loop = swiperSlide.length > 2;

		/* 設定按鈕 title */
		swiperNextEl.setAttribute('title', a11y.nextSlideMessage);
		swiperPrevEl.setAttribute('title', a11y.prevSlideMessage);

		/* 手機板控制項目隱藏/開啟 */
		var galleryModalTapTimer = null;
		var galleryMobileCtrlHideClass = 'is-hide';
		var galleryMobileCtrlToggle = function() {
			swiperEl.classList.toggle(galleryMobileCtrlHideClass);
		}
		var galleryMobileCtrlHide = function() {
			swiperEl.classList.add(galleryMobileCtrlHideClass);
		}
		var galleryMobileCtrlShow = function() {
			swiperEl.classList.remove(galleryMobileCtrlHideClass);
		}

		galleryTopModal = new Swiper(swiperTarget, {
			spaceBetween: 10,
			a11y: a11y,
			loop: loop,
			lazy: true,
			observer: true,
			zoom: {
				minRatio: 1,
				maxRatio: 4,
				toggle: false
			},
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			pagination: {
				el: swiperPageEl,
				type: 'fraction',
				renderFraction: function (currentClass, totalClass) {
					return '第 <span class="' + currentClass + '"></span> 張' +
							'，' +
							'共 <span class="' + totalClass + '"></span> 張';
				}
			},
			on: {
				init () {
					this.modalInit = false;
					
					// ↓為了符合鍵盤操控
					var target = this.$el[0];
					swiperLoopTabRemove(target); // 設定 tabindex = -1
					swiperLoopTabAdd(target, this); // 設定 tabindex = 0

					// 移除Loop重複的 swiper-slide 的 id (避免id重複，影響到無障礙部分)
					var swiperDuplicate = swiperTargetEl.querySelectorAll('.swiper-slide-duplicate .gallery-modal__photo__gallery-top__desc');
					[].forEach.call(swiperDuplicate, function(item) {
						item.removeAttribute('id');
					});
				},
				click () {
					if (window.innerWidth < 640) {
						galleryModalTapTimer && clearTimeout(galleryModalTapTimer);
						galleryModalTapTimer = setTimeout(function() {
							galleryMobileCtrlToggle();
						}, 200);
					}
				},
				doubleTap () {
					galleryModalTapTimer && clearTimeout(galleryModalTapTimer);
				}
			}
		});

		// 更改Zoom形式
		// Scale: 1 → 2 → 4
		// 觸發： PC單點擊、手機雙點擊
		var zoomMaxClass = 'swiper-slide-zoomed-max';
		var buildClickZoom = function() {
			// 歸零
			galleryTopModal
				.on('slideChange', function() {
					var swiper = this;
					var currentSlide = swiper.slides[swiper.activeIndex];
					if(currentSlide !== undefined) {
						var zoomWrap = currentSlide.querySelector('.swiper-zoom-container');
						zoomWrap.setAttribute('data-swiper-zoom', 1);
						
						currentSlide.classList.remove('swiper-slide-zoomed');
						currentSlide.classList.remove(zoomMaxClass);
					}
				})

			if(isMobile) {
				// 雙擊觸發Zoom(Mobile限定)
				galleryTopModal
					.on('doubleTap', function(e) {
						var swiper = this;
						var currentSlide = swiper.slides[swiper.activeIndex];
						var zoomWrap = currentSlide.querySelector('.swiper-zoom-container');

						currentSlide.classList.remove(zoomMaxClass);

						if(galleryTopModal.zoom.scale === 1 || galleryTopModal.zoom.scale === '1') {
							zoomWrap.setAttribute('data-swiper-zoom', 2);
							
							setTimeout(() => {
								swiper.zoom.in(e);
							}, 10);
						} else if (galleryTopModal.zoom.scale === 2 || galleryTopModal.zoom.scale === '2') {
							zoomWrap.setAttribute('data-swiper-zoom', 4);
							currentSlide.classList.add(zoomMaxClass);
							setTimeout(() => {
								swiper.zoom.in(e);
							}, 10);
						} else {
							zoomWrap.setAttribute('data-swiper-zoom', 1);
							setTimeout(() => {
								swiper.zoom.out(e);
							}, 10);
						}
					});
			} else {
				// 點擊觸發Zoom(PC限定)
				galleryTopModal
					.on('tap', function(e) {
						var swiper = this;
						var currentSlide = swiper.slides[swiper.activeIndex];
						var zoomWrap = currentSlide.querySelector('.swiper-zoom-container');

						currentSlide.classList.remove(zoomMaxClass);

						if(galleryTopModal.zoom.scale === 1 || galleryTopModal.zoom.scale === '1') {
							zoomWrap.setAttribute('data-swiper-zoom', 2);
							
							setTimeout(() => {
								swiper.zoom.in(e);
							}, 10);
						} else if (galleryTopModal.zoom.scale === 2 || galleryTopModal.zoom.scale === '2') {
							zoomWrap.setAttribute('data-swiper-zoom', 4);
							currentSlide.classList.add(zoomMaxClass);
							setTimeout(() => {
								swiper.zoom.in(e);
							}, 10);
						} else {
							zoomWrap.setAttribute('data-swiper-zoom', 1);
							setTimeout(() => {
								swiper.zoom.out(e);
							}, 10);
						}
					});
			}
		}

		var modalSlider = $('#modal-slider');
		var modalTimer = null;
		var albumListImgBox = '.album-list__img-box';
		var albumFocusTimer = null;
		var docKeyDownActiveEvent = false;
		
		var isEnter = false;
		
		modalSlider.css('opacity', 0);
		
		var keycodeTimer = null;

		var documentFocusKeyDownHandler = function(e) {
			isEnter = e.keyCode === 13;
			keycodeTimer && clearTimeout(keycodeTimer);
			keycodeTimer = setTimeout(() => {
				isEnter = false
			}, 200);
		}

		$(document)
			.on('click', albumListImgBox, function() {
				openIndex = $(this).parent().index();
			})
			.on('focus', albumListImgBox, function() {
				// 流程：Focus→啟動監控鍵盤事件→確認是否是Enter
				albumFocusTimer && clearTimeout(albumFocusTimer);
				if (!docKeyDownActiveEvent) {
					docKeyDownActiveEvent = true;
					$(document).on('keydown', documentFocusKeyDownHandler);
				}
			})
			.on('focusout', albumListImgBox, function() {
				// 流程：Focusout→停止監控鍵盤事件
				albumFocusTimer && clearTimeout(albumFocusTimer);
				albumFocusTimer = setTimeout(() => {
					docKeyDownActiveEvent = false
					$(document).off('keydown', documentFocusKeyDownHandler);
				}, 1000);
			})

		modalSlider
			.on('open.zf.reveal', function () {
				galleryMobileCtrlShow();

				if(!galleryTopModal.modalInit) {
					galleryTopModal.modalInit = true;
					galleryTopModal.update();

					var $self = $(this);
					if(modalTimer !== null) clearTimeout(modalTimer);
					modalTimer = setTimeout( function() {
						// 調整內容為垂直置中
						var top = (wh - $self.innerHeight()) / 2 - 40;
						if(top < 0) top = 0;
						$self.css({
							'top': top,
							'opacity': ''
						});
						modalTimer = null;

						// 重新定義Zoom的模式
						buildClickZoom(galleryTopModal.slides);

						// ↓為了符合鍵盤操控
						var target = galleryTopModal.$el[0];
						swiperLoopTabRemove(target); // 設定 tabindex = -1
						swiperLoopTabAdd(target, galleryTopModal); // 設定 tabindex = 0

						// 移除Loop重複的 swiper-slide 的 id (避免id重複，影響到無障礙部分)
						var swiperDuplicate = galleryTopModal.$el[0].querySelectorAll('.swiper-slide-duplicate .gallery-modal__photo__gallery-top__desc');
						[].forEach.call(swiperDuplicate, function(item) {
							item.removeAttribute('id');
						});

					}, 300);
				}
				galleryTopModal.slideToLoop(openIndex);
				galleryTopModal.lazy.load(openIndex);

				// 如果是鍵盤Enter開啟才Focus
				if (isEnter) {
					setTimeout(() => {
						modalSlider.find('.swiper-slide[data-swiper-slide-index="'+openIndex+'"]').eq(0).focus();
					}, 500);
				}

				$(this).blur();
			});

		// Mobile版本 滑動後關閉Slider
		if(isMobile && window.Hammer) {
			var myElement = document.querySelector('.gallery-modal__photo__swiper-box');
			var mc = new Hammer(myElement);
			mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });

			var revealOverlay = modalSlider.parent();
			var bgOpacity = parseFloat(revealOverlay.css('background-color').split(',')[3].replace(/\)/g, ''));

			var lastY = 0;

			mc.on("panmove", function(e) {
				// 如果正進行放大 => 不動作
				if(galleryTopModal.zoom.gesture.$slideEl !== undefined) return false;

				lastY = Math.abs(e.deltaY);
				myElement.style.transform = "translateY(" + e.deltaY + "px)";
				revealOverlay.css('background', 'rgba(0,0,0,' + (bgOpacity - lastY * 0.005) + ')');
			}).on("panend", function(e) {
				// 如果正進行放大 => 不動作
				if(galleryTopModal.zoom.gesture.$slideEl !== undefined) return false;

				myElement.style.transform = "translateY(0)";
				revealOverlay.css('background', '');
				if(lastY > 50) {
					modalSlider.foundation('close');
				}
			});

			// Slider 拖曳時還原樣式
			galleryTopModal.on('sliderMove', function() {
				mc.set({ enable: false });
				myElement.style.transform = "translateY(0)";
				revealOverlay.css('background', '');
			}).on('transitionEnd', function() {
				mc.set({ enable: true });
			});
		}
	}

	registerListener('load', buildSwiper__albumLightbox);
	/* --------------------------------------- */
	/*
		* 關注 Sony 近期活動
		*/

	var sonyActiveEl = document.querySelector('.sony-activity');

	var sonyActive__buildSwiper = function() {
		var swiperTarget = '#sony-activity-carousel',
			swiperTargetEl = document.querySelector(swiperTarget);
		if(swiperTargetEl === null) return false;
		
		var swiperEl = swiperTargetEl.parentElement,
			swiperNextEl = swiperEl.querySelector('.swiper-button-next'),
			swiperPrevEl = swiperEl.querySelector('.swiper-button-prev'),
			swiperPageEl = swiperEl.querySelector('.swiper-pagination');
			
		var swiperSlider = swiperEl.querySelectorAll('.swiper-slide'),
			swiperLen = swiperSlider.length,
			swiperLoopL = swiperLen > 3,
			swiperLoopM = swiperLen > 1 && swiperLen < 4; // 於Small & Medium 數量 2 ~ 3 要Loop

		/* 設定按鈕 title */
		swiperNextEl.setAttribute('title', a11y.nextSlideMessage);
		swiperPrevEl.setAttribute('title', a11y.prevSlideMessage);

		var breakpoint = window.matchMedia('(min-width: 1024px)');

		var swiper;
		var focusEventBuild = false; // 確認是否建立Focus監聽
		var runReBuildSwiper = function (loop) {
			// 隱藏 控制按鈕
			if(!loop) {
				swiperNextEl.classList.add('hide');
				swiperPrevEl.classList.add('hide');
				swiperPageEl.classList.add('hide');
			} else {
				swiperNextEl.classList.remove('hide');
				swiperPrevEl.classList.remove('hide');
				swiperPageEl.classList.remove('hide');
			}

			swiper = new Swiper(swiperTarget, {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: true,
				slideToClickedSlide: true,
				a11y: a11y,
				loop: swiperLen > 2,
				simulateTouch: swiperLen > 1,
				lazy: {
					loadPrevNext: true
				},
				navigation: {
					nextEl: swiperNextEl,
					prevEl: swiperPrevEl,
				},
				pagination: {
					el: swiperPageEl,
					clickable: true
				},
				breakpoints: {
					1024: {
						slidesPerView: 3,
					}
				},
				on: {
					init () {
						swiperLoopTabRemove(this.$el[0])
					},
					breakpoint () {
						swiperLoopTabRemove(this.$el[0])
					}
				}
			});

			// Focus Change Slide (PC)
			if (focusEventBuild) { return false }
			focusEventBuild = true;
			var focusTimer = null;
			var swiperSlideLinkEl = swiperEl.querySelectorAll('.swiper-slide a');
			[].forEach.call(swiperSlideLinkEl, function(item) {
				item.addEventListener('focus', function() {
					if(!isMobile) {
						clearTimeout(focusTimer);
						var slide = item.parentElement;
						var elIndex = $(slide).index();
						var index = parseInt(slide.dataset.swiperSlideIndex);
						if (loop) {
							swiper.slideToLoop(index);
						} else {
							swiper.slideTo(index);
						}
						swiper.lazy.loadInSlide(elIndex + 1)
					}
				});
				item.addEventListener('focusout', function() {
					if(!isMobile) {
						focusTimer = setTimeout(() => {
							swiper.autoplay.start()
						}, 500);
					}
				});
			});
		}


		// 是否介於2~3之間 ? 是否為Large(是 = loop，否 = no loop) : 數量1、4直接看swiperLoop設定
		var swiperLoop = swiperLoopM ? !breakpoint.matches : swiperLoopL;
		runReBuildSwiper(swiperLoop);

		// 如果數量介於 2 ~ 3之間每次切換breakpoint都要重新生成
		if(swiperLoopM) {
			var breakpoint = window.matchMedia('(min-width: 1024px)');
			var breakpointChecker = function () {
				if(swiper !== undefined) swiper.destroy(true, true);
				runReBuildSwiper(!breakpoint.matches);
			}
			breakpoint.addListener(breakpointChecker);
		}
	}

	var sonyActiveElShow = {
		old: false,
		build: false,
		set value(value) {
			if(this.old !== value) {
				var self = this;
				self.old = value;

				if(value) {
					sonyActiveEl.classList.add('is-show');
					if(!self.build) {
						self.build = true;
						sonyActive__buildSwiper();
					}
				} else {
					sonyActiveEl.classList.remove('is-show');
				}
			}
		}
	};
	
	var sonyActive__scrollHandler = function() {
		sonyActiveElShow.value = isInViewport(sonyActiveEl);
	}

	var sonyActive__init = function() {
		if (sonyActiveEl === null) { return false }

		sonyActive__scrollHandler();
		registerListener('scroll', throttle(sonyActive__scrollHandler, 20, 50));
	}

	registerListener('load', sonyActive__init);
	
})(window, document);

